exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".editor-component {\n  border: 2px solid #eee;\n  background: white;\n  padding: 0 1em;\n  min-height: 6em; }\n", ""]);

